<template>
  <div v-show="gameCompleted" class="game-over">
    <Avatar
      class="game-over__avatar"
      name="Sherlock"
      game="expandedForm"
      :level="5"
      :progress="0.8"
      image="https://images.unsplash.com/photo-1529040181623-e04ebc611e25?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9"
    />
    <Brand type="light" position="bottom-right" />
    <img class="foreground" src="@/assets/practices/pet_life/foreground.svg" alt="foreground" />
    <div class="bar"></div>
    <div class="main">
      <div class="game-over__window">
        <div class="game-over__window--message">
          <p v-if="playerScore >= 300">{{ message.win }}</p>
          <p v-else>{{ message.lose }}</p>
        </div>
        <!-- <p class="game-over__you-scored">You scored:</p> -->
        <div class="game-over__window--points">
          <div id="stars-left"></div>
          <p>{{ playerScore }} Points</p>
          <div id="stars-right"></div>
        </div>
        <div class="game-over__cats">
          <div id="black-cat-gameover"></div>
          <div id="orange-cat-gameover"></div>
          <div id="white-cat-gameover"></div>
        </div>
      </div>
    </div>
    <div class="bar-bottom">
      <div class="button--left">
        <div class="button--left--top" ontouchstart @click="clickRetryButton">
          <!-- <p class="button--left--text">Retry</p> -->
          <img id="retry" src="@/assets/practices/global/retry.svg" alt="retry" />
          <img src="@/assets/practices/pet_life/button_blue_top.svg" alt="button_top" />
        </div>
        <img
          class="button--right--bottom"
          src="@/assets/practices/pet_life/button_blue_bottom.svg"
          alt="button_bottom"
        />
      </div>
      <div :key="render" class="buttons--center">
        <Button />
        <Button />
        <Button />
      </div>
      <div class="button--right">
        <div class="button--right--top" ontouchstart>
          <p class="button--right--text">Next Game</p>
          <img src="@/assets/practices/pet_life/button_blue_top.svg" alt="button_top" />
        </div>
        <img
          class="button--right--bottom"
          src="@/assets/practices/pet_life/button_blue_bottom.svg"
          alt="button_bottom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
// import exercises from '@/assets/practices/data/pet_life/exercises.json';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'GameOver',
  components: {
    Avatar: () => import('@/components/practices/Avatar.vue'),
    Brand: () => import('@/components/practices/Brand.vue'),
    Button: () => import('@/components/practices/pet_life/Button.vue'),
  },
  data: () => ({
    message: {
      win: 'Congratulations!',
      lose: 'You can do better, try again!',
    },
    render: 0,
  }),
  computed: {
    ...mapGetters({
      currentExercise: 'petLife/currentExercise',
      currentLives: 'petLife/currentLives',
      exerciseCompleted: 'petLife/exerciseCompleted',
      gameCompleted: 'petLife/gameCompleted',
      playerScore: 'petLife/playerScore',
    }),
  },
  watch: {
    gameCompleted(value) {
      if (value) {
        if (this.playerScore > 200) {
          sounds.globalScoreWin.play();
        }
        if (this.playerScore <= 200 && this.playerScore > 0) {
          sounds.globalScorePass.play();
        }
        if (this.playerScore === 0) {
          sounds.globalScoreLose.play();
        }
      }
    },
  },
  mounted() {
    const orangeCatGameOverAnimation = lottie.loadAnimation({
      container: document.getElementById('orange-cat-gameover'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_cat_orange.json',
    });
    const blackCatGameOverAnimation = lottie.loadAnimation({
      container: document.getElementById('black-cat-gameover'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_cat_black.json',
    });
    lottie.loadAnimation({
      container: document.getElementById('white-cat-gameover'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_cat_white.json',
    });
    const starsLeft = lottie.loadAnimation({
      container: document.getElementById('stars-left'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/global/animations/stars_left.json',
    });
    const starsRight = lottie.loadAnimation({
      container: document.getElementById('stars-right'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/global/animations/stars_right.json',
    });
    orangeCatGameOverAnimation.play();
    blackCatGameOverAnimation.play();
    starsLeft.setSpeed(0.75);
    starsRight.setSpeed(0.75);
  },
  methods: {
    ...mapActions({ resetGame: 'petLife/resetGame' }),
    clickRetryButton() {
      sounds.globalButton.play();
      this.resetGame();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.game-over {
  @include flex-center;
  flex-direction: column;
  height: 100vh;
  width: 100vw;

  // &__avatar {
  //   z-index: 100;
  // }

  &__window {
    @include flex-center;
    border-radius: 7.5vh;
    flex-direction: column;
    text-align: center;
    z-index: 1;

    &--message {
      font-size: 1.15em;
      margin-bottom: 3vh;
    }

    &you-scored {
      font-size: 0.75em;
    }

    &--points {
      @include flex-center;
      flex-direction: row;
      font-size: 1.35em;

      p {
        font-family: 'Minecrafter', sans-serif;
        font-size: 1.75em;
      }

      #stars-left,
      #stars-right {
        height: 4em;
        width: 4em;
        margin-top: -10vh;
      }
    }
  }

  &__cats {
    display: flex;
    justify-content: space-evenly;
    width: 100%;

    #black-cat-gameover,
    #orange-cat-gameover,
    #white-cat-gameover {
      height: 18vh;
      width: calc(18vh * 1.65);
      z-index: 1;
    }
  }
}

.foreground {
  display: block;
  height: 80vh;
  position: absolute;
  width: 90vw;
}

.bar,
.bar-bottom,
.explanation,
.main {
  @include flex-center;
  box-sizing: border-box;
  width: 85vw;
  z-index: 1;
}

.bar,
.bar-bottom {
  background-color: #77afb1;
  height: 10vh;
  z-index: 2;
}

.bar {
  border-radius: 25px 25px 0 0;
  justify-content: space-between;

  &__points,
  &__lives {
    margin: 0 1vw;
  }

  &__points {
    font-size: 6vh;
    font-family: 'Minecrafter', sans-serif;
    left: 2vw;
    line-height: 0;
  }

  &__lives {
    left: 2vw;

    ul {
      @include flex-center;
      list-style: none;

      li {
        margin: 0 0.5vw;
        @include flex-center;

        .life {
          height: 5.5vh;
        }
      }
    }
  }
}

.bar-bottom {
  border-radius: 0 0 25px 25px;
  justify-content: space-evenly;

  .button--left,
  .button--right {
    transform: translate(0, 8vh);
    width: 25%;
  }

  .buttons--center {
    @include flex-center;
    justify-content: space-around;
    width: 40%;
  }

  .button--right,
  .button--left {
    @include flex-center;

    img {
      width: 25vh;
    }

    &--text,
    &--top,
    &--bottom {
      position: absolute;
    }

    &--top {
      @include flex-center;
      text-align: center;
      z-index: 1;

      img {
        width: 24.5vh;
      }

      &:active {
        transform: translate(0, 8%);
      }
    }

    &--text {
      color: $pet-life-color-main;
      font-family: 'VCR OSD Mono', sans-serif;
      font-size: 100%;
      line-height: 0.85;
      z-index: 2;

      cursor: pointer;
    }

    &--bottom {
      transform: translate(0, 31%);
    }
  }
}

.main {
  background-color: #d3edef;
  // font-family: 'Rimouski', sans-serif;
  min-height: 45vh;
  position: relative;

  &__question {
    position: absolute;
    text-align: center;
    width: 60%;
  }

  .feedback__correct,
  .feedback__incorrect {
    bottom: -8.5vh;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    position: absolute;
  }

  .feedback__correct {
    left: 0.25vw;
  }

  .feedback__incorrect {
    right: 0.25vw;
  }

  .rise {
    animation: rise 1s forwards;
  }
}

.explanation {
  background-color: #000000dd;
  border-radius: 25px;
  color: $pet-life-color-main;
  // font-family: 'Rimouski', sans-serif;
  min-height: 65vh;
  position: absolute;

  p {
    text-align: center;
    width: 60%;
  }
}

#retry {
  height: 1em;
  padding: 0 1em;
  position: absolute;
}

@keyframes rise {
  0% {
    bottom: -8.5vh;
  }
  100% {
    bottom: 0vh;
  }
}

@media (max-aspect-ratio: 8/5) {
  .game-over {
    &__window {
      &--points {
        @include flex-center;
        flex-direction: row;
        font-size: 1.35em;

        p {
          font-size: 1.5em;
        }
      }
    }

    &__cats {
      transform: translate(0, 1.75vh);

      #black-cat-gameover,
      #orange-cat-gameover,
      #white-cat-gameover {
        height: 15vh;
        width: calc(15vh * 1.65);
        z-index: 1;
      }
    }
  }

  .button-left,
  .button--right {
    &--text {
      transform: translate(0, -5%);
    }
  }
}
</style>
